










































import axios from 'axios';
import { User } from '../../models/user';

import router from '../../routing/router'

import { Component, Prop, Vue } from 'vue-property-decorator';

import { userWebservice } from '../../webservices/user' 

@Component
export default class Login extends Vue {
    
    // Data
    protected user: User = {
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        password_confirmation: '',
    }
    protected disabled:boolean = false
    protected errorMsg: string = ''

    // Mounted is called initially
    mounted() {

    }

    // Methods
    login() {
        console.log("Login called")

        if(this.user.email === '' || this.user.password === '') {
            this.errorMsg = 'Die Emailadresse oder das Passwort fehlt.'
            return
        }

        let self = this

        userWebservice.login(this.user.email, this.user.password).then(function (response) {
            self.errorMsg = '';
            self.$store.commit('account/setApiToken', response.data.api_token)

            userWebservice.getUserInfo().then(function (response) {
                self.$store.commit('account/setCurrentUser', response.data)
                self.$router.push({ path: '/manage' })
            })
        }).catch(function (error) {
            self.errorMsg = 'Das Passwort oder der Benutzername sind nicht korrekt'
            console.log(error)
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/auth/Login.vue